// extracted by mini-css-extract-plugin
export default {"mungsList":"mungsnewscomp_mungsList__rWDzY","mungsList_menu":"mungsnewscomp_mungsList_menu__5dOdG","active":"mungsnewscomp_active__3wY2N"};